export default __webpack_public_path__ + "static/media/quote.994ce33a.svg";